import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Component, onMounted, ref, useSlots, watchEffect } from "vue";
import TabsMenu from "./TabsMenu.vue";
import type { TabPanelProps } from "./TabPanel.vue";
import { useRoute } from "vue-router";
interface TabsProps {
  onTab?: (index: number) => boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    onTab: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  onTab?: (index: number) => boolean;
}

const route = useRoute();
const index = Number(route.query["index"]);
const activeIndex = ref(isNaN(index) ? 0 : index);
const contentRef = ref<HTMLDivElement>();
const slots = useSlots();
const menu = ref<string[]>([]);

const getIndex = () => activeIndex.value;



const setActiveIndex = (index: number) => {
  if (props.onTab !== undefined && !props.onTab(index)) return;
  activeIndex.value = index;
};

watchEffect(() => {
  contentRef.value?.querySelector(".active")?.classList.remove("active");
  contentRef.value?.querySelector(`[data-index="${activeIndex.value}"]`)?.classList.add("active");
});

onMounted(() => {
  if (slots.default) {
    const children = slots.default();
    if (children.find((p) => !(p.type as Component).name || (p.type as Component).name !== "tab-panel")) {
      throw new Error("只能使用tab-panel组件");
    }

    menu.value = children.map((p) => (p.props as TabPanelProps).title);
  }
  if (contentRef.value) {
    const children = Array.from(contentRef.value.children);
    children.forEach((element, index) => {
      element.setAttribute("data-index", index.toString());
    });
  }
});

expose({
  getIndex,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrap)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.nav)
    }, [
      _createVNode(TabsMenu, {
        data: menu.value,
        "active-index": activeIndex.value,
        onClick: setActiveIndex
      }, null, 8, ["data", "active-index"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content),
      ref_key: "contentRef",
      ref: contentRef
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})